/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import Autocomplete from "components/common_components/Autocomplete/Autocomplete";
import FormsContext from "../FormsContext";
import FileCaseLink from "./FileCaseLink";

const isSameFileCase = (a, b) => a?.module === b?.module && a?.fileCaseId === b?.fileCaseId;

/** Case of the form's client; clearing it removes the association. */
const FileCaseSelect = ({ clientId, value, onChange }) => {
    const dispatch = useDispatch();
    const { FormClients } = useContext(FormsContext);
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!clientId) return;
        setIsLoading(true);
        FormClients.fileCases.getByClientId({
            clientId,
            onSuccess: (data) => {
                setOptions(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }, [clientId]);

    // Before the options load, show the stored association as-is
    const selected = value?.fileCaseId ? options.find((x) => isSameFileCase(x, value)) || value : null;

    return (
        <div className="item file-case-select" style={{ width: "40%" }}>
            <b>Case</b>
            <div className="file-case-select__control">
                <Autocomplete
                    value={selected}
                    options={options}
                    onChange={(fileCase) => onChange(fileCase || null)}
                    label=""
                    variant="standard"
                    placeholder={isLoading ? "Loading cases..." : "No case"}
                    disabled={isLoading}
                    renderOption={(fileCase) => (
                        <span>
                            {fileCase.fileNo}
                            {fileCase.type && <small>{` · ${fileCase.type}`}</small>}
                            {fileCase.status && <small>{` (${fileCase.status})`}</small>}
                        </span>
                    )}
                    getOptionLabel={(fileCase) => fileCase?.fileNo || ""}
                    getOptionSelected={isSameFileCase}
                />
                {selected && <FileCaseLink {...selected} iconOnly />}
            </div>
        </div>
    );
};

FileCaseSelect.propTypes = {
    clientId: PropTypes.number,
    value: PropTypes.shape({
        module: PropTypes.string,
        fileCaseId: PropTypes.number,
        fileNo: PropTypes.string,
    }),
    onChange: PropTypes.func,
};

FileCaseSelect.defaultProps = {
    clientId: undefined,
    value: null,
    onChange: () => {},
};

export default FileCaseSelect;
